import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { RenovacionVehiculo } from "./renovacion-vehiculo.component";
import { RenovacionService } from "./renovacion.service";
import { UtilService } from "../../../components/common/utils/util.service"
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload'
import { RenovacionOtrosRamos } from "./renovacion-otros-ramos.component";
import { RenovacionAsistenciaMedica } from "./renovacion-asistencia-medica.component";
import { RenovacionVivienda } from "./renovacion-vivienda.component"
import { CalendarModule } from 'primeng/primeng';
import { Ng2Webstorage } from "ngx-webstorage";


@NgModule({
    declarations: [RenovacionVehiculo, RenovacionOtrosRamos, RenovacionAsistenciaMedica, RenovacionVivienda],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        CalendarModule,
        Ng2Webstorage],
    providers: [RenovacionService, UtilService],
    exports: [RenovacionVehiculo, RenovacionAsistenciaMedica, RenovacionOtrosRamos, RenovacionVivienda]
})

export class RenovacionModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion.module.ts